enum INVENTORY_ACTION_TYPES {
  FETCH_DOCTORS_LIST = 'FETCH_DOCTORS_LIST',
  SAVE_DOCTORS_LIST = 'SAVE_DOCTORS_LIST',
  FETCH_DOCTORS_IMAGES = 'FETCH_DOCTORS_IMAGES',
  DOCTORS_IMAGES = 'DOCTORS_IMAGES',
  FETCH_IP_INCLUSION_MASTER = 'FETCH_INCLUSION_MASTER_IP',
  IP_INCLUSION_MASTER_DATA = 'INCLUSION_MASTER_DATA_IP',
  FETCH_IP_DEPARTMENT_MASTER = 'FETCH_IP_DEPARTMENT_MASTER',
  IP_DEPARTMENT_MASTER_DATA = 'IP_DEPARTMENT_MASTER_DATA',
  SET_SELECTED_DOCTORS_LIST = 'SET_SELECTED_DOCTORS_LIST',
  FETCH_FILE_BYTES_DATA = 'FETCH_FILE_BYTES_DATA',
}

export default INVENTORY_ACTION_TYPES;
